import React from 'react';
import { Grid, Paper } from '@mui/material';
import { Alert, Snackbar } from '@mui/material';
import LastSavedIndicator from '../LastSavedIndicator';

const FormLayoutWrapper = ({
  // Layout classes
  classes,

  // Children components
  navigationComponent,
  children,

  // Alert props
  alertOpen = false,
  alertMessage,
  alertStatus,
  onAlertClose,

  // Paper props
  paperClassName,

  // Grid props
  layoutClassName,
  containerSpacing = 1,

  // Last saved props
  lastSaved,

  // Additional props for flexibility
  showAlert = true,
  mainContentGridProps = { xs: 12, md: 8 },
}) => {
  const renderAlert = () => {
    if (!showAlert || !alertOpen) return null;

    return (
      <Snackbar open={alertOpen} onClose={onAlertClose} autoHideDuration={6000}>
        <Alert
          onClose={onAlertClose}
          severity={alertStatus}
          sx={{ width: '100%' }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    );
  };

  return (
    <Grid
      container
      spacing={containerSpacing}
      className={layoutClassName || classes.layout}
    >
      {/* Navigation Menu */}
      {navigationComponent}

      {/* Main Content */}
      <Grid item {...mainContentGridProps}>
        {renderAlert()}

        <Paper
          className={paperClassName || classes.paper}
          sx={{ position: 'relative' }}
        >
          <LastSavedIndicator lastSaved={lastSaved} />
          {children}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default FormLayoutWrapper;
